import * as qs from 'query-string';
import history from './history';


export const REDIRECT_KEY = 'fromUrl';
export const VEHICLE_NUMBER_KEY = 'vehicleNumber';
export const ON_DEMAND_FILTER_KEY = 'onDemand';

const popQueryParameter = parameter => {
  let parameterValue = null;
  const paramsParsed = qs.parse(history.location.search);
  if (paramsParsed[parameter]) {
    parameterValue = paramsParsed[parameter];
    delete paramsParsed[parameter];
    history.replace(`${history.location.pathname}?${qs.stringify(paramsParsed)}`);
  }
  return parameterValue;
};

export {popQueryParameter};
export default popQueryParameter;
